export default __webpack_public_path__ + "alberta-arrow-left.ac253c57fdd48d533109.svg";